import React from 'react';

const SelectWrapperPrefix = ({ children, prefix, ...rest }) => {
  return (
    <div className="gx-selectwrapperprefix-container">
      <div className="select-prefix">{prefix}</div>
      {React.cloneElement(children, rest)}
    </div>
  );
};

export default SelectWrapperPrefix;
